<template>
  <CustomModal
    :is-modal-open="isOpen"
    overlay="dark"
    :with-header="true"
    :with-footer="true"
    custom-classes="tw:h-screen tw:md:h-auto tw:w-[100vw] tw:md:max-w-[940px] tw:md:rounded-xl tw:rounded-none"
    data-testid="rc-plus-cross-sell-popup"
    @toggleModal="$emit('close')"
    @onClickAway="$emit('close')">
    <template #modalHeader>
      <h3 class="tw:font-bold tw:text-xl">{{ $t('rc_plus_upsell_header') }}</h3>
    </template>

    <RateConnectPlusCrossSellOfferContent
      :is-price-fetching="isPriceFetching"
      :discounted-monthly-price="discountedMonthlyPrice"
      :monthly-price="monthlyPrice"
      :total-price-before-taxes="totalPriceBeforeTaxes"
      :base-subscription-full-term-price="baseSubscriptionFullTermPrice" />

    <template #modalFooter>
      <div class="tw:flex tw:flex-col tw:md:flex-row tw:gap-y-4 tw:justify-end tw:w-full">
        <GhostButton data-testid="rc-plus-cross-sell-popup-remind-later-cta" @click="$emit('remindLater')">
          {{ $t('rc_plus_upsell_reminder_cta') }}
        </GhostButton>
        <MainButton
          class="tw:md:ml-6"
          :data-testid="
            plusUpsellSubscribeAction === 'login-as-admin'
              ? 'rc-plus-cross-sell-popup-login-as-admin-cta'
              : 'rc-plus-cross-sell-popup-continue-cta'
          "
          @click="$emit('continue')">
          {{ plusUpsellSubscribeAction === 'login-as-admin' ? $t('rc_admin_log_in_cta') : $t('setup_next') }}
        </MainButton>
      </div>
    </template>
  </CustomModal>
</template>

<script setup lang="ts">
import CustomModal from '@/components/base/CustomModal.vue'
import GhostButton from '@/components/base/buttons/GhostButton.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import RateConnectPlusCrossSellOfferContent from '@/components/rateConnect/studioPlusCrossSell/RateConnectPlusCrossSellOfferContent.vue'
import type { PlusUpsellSubscribeAction } from '@/composables/useRcPlusCrossSell'

interface Props {
  isOpen: boolean
  isPriceFetching: boolean
  discountedMonthlyPrice: number
  monthlyPrice: number
  totalPriceBeforeTaxes: number
  baseSubscriptionFullTermPrice: number
  plusUpsellSubscribeAction: PlusUpsellSubscribeAction
}

defineProps<Props>()

defineEmits<{
  close: []
  continue: []
  remindLater: []
}>()
</script>
